
export const SECTION_TYPE_HTML_PACKAGE = 'html_package';
export const SECTION_TYPE_IFRAME_EMBED = 'iframe_embed';
export const SECTION_TYPE_PDF = 'pdf';
export const SECTION_TYPE_PRESENTATION = 'presentation';
export const SECTION_TYPE_SLIDESHOW = 'slideshow';
export const SECTION_TYPE_TILES = 'tiles';
export const SECTION_TYPE_TEXT = 'text';
export const SECTION_TYPE_VIDEOPLAYLIST = 'videoplaylist';
export const SECTION_TYPE_JOB_FEED = 'job_feed';
export const SECTION_TYPE_ACCORDION = 'accordion';
export const SECTION_TYPE_TABS = 'tabs';

// Section types that should not be shown when adding sections to tabs
export const DO_NOT_SHOW_IN_TABS = [
  SECTION_TYPE_TABS
];

export const CONTENT_TYPE_TEXT = 'text';
export const CONTENT_TYPE_PHOTO = 'photo';
export const CONTENT_TYPE_IFRAME_EMBED = 'iframe_embed';
export const CONTENT_TYPE_HTML_PACKAGE = 'html_package';
export const CONTENT_TYPE_PRESENTATION = 'ppt';
export const CONTENT_TYPE_OTHER = 'other';
export const CONTENT_TYPE_WEB_PREVIEW = 'web_preview';
export const CONTENT_TYPE_VIDEO = 'video';
export const CONTENT_TYPE_YOUTUBE = 'youtube';
export const CONTENT_TYPE_FORM = 'form';
export const CONTENT_TYPE_FILE = 'file';


export const SECTION_TYPE_NAMES = [
  SECTION_TYPE_HTML_PACKAGE,
  SECTION_TYPE_IFRAME_EMBED,
  SECTION_TYPE_PDF,
  SECTION_TYPE_PRESENTATION,
  SECTION_TYPE_SLIDESHOW,
  SECTION_TYPE_TEXT,
  SECTION_TYPE_TILES,
  SECTION_TYPE_VIDEOPLAYLIST,
  SECTION_TYPE_JOB_FEED,
  SECTION_TYPE_ACCORDION,
  SECTION_TYPE_TABS
];